import api from 'api'

export type CreateIndeedFlexLongTermAssignmentParams = {
  ifClientId: number
  ifJobId: number
  assignmentName: string
  specificWorkerIds?: number[]
}

export type CreateIndeedFlexLongTermAssignmentResponse = {
  shiftIds: number[]
}

export const createIndeedFlexLongTermAssignment = async (
  params: CreateIndeedFlexLongTermAssignmentParams
): Promise<CreateIndeedFlexLongTermAssignmentResponse> => {
  const result = await api.post<CreateIndeedFlexLongTermAssignmentResponse>(
    '/admin/indeed_flex/long_term_assignments/create',
    params
  )
  return result.data
}
